import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/body-fat-calculator',
  component: () => import('../../routes/BodyFatCalculator.svelte'),
  card: {
    id: 'body-fat-calculator',
    title: 'Body Fat Calculator',
    description: 'Estimate your body fat percentage using the US Navy circumference method. Enter your measurements to see your body fat category and fat mass.',
    icon: 'monitor_weight',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/body-fat-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Body Fat Calculator – US Navy Method Body Fat Estimator',
    description: 'Free body fat calculator using the US Navy method. Enter your height and body measurements to estimate body fat percentage and see your fitness category.',
  },
};

export default meta;
